import React from 'react';
import { useTranslation } from 'react-i18next';
import copyright from '../../assets/images/icn-logo.svg';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer>
      <span>
        {t('powered_by')}
        <a href="https://nternow.com/" rel="noreferrer noopener" target="_blank">
          <img src={copyright} alt={t('copyright')} />
        </a>
      </span>
    </footer>
  );
};

export default Footer;
